module.exports = __webpack_public_path__ + "img/product_51.352f057.webp";